import React from "react";
import { alpha, Box, Typography, useTheme } from "@mui/material";
import styled from "@emotion/styled";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { useAppLayout } from "@providers/AppLayoutProvider";
import { MandatorsSlugSelect } from "@components/common/layouts/AppSidebar/MandatorsSlugSelect";

const StyledLink = styled(Link)`
  text-decoration: none;
  font-size: 14px;
`;

const LinksContainer = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const Dot = styled(Box)`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.sidebar.textOnSidebar};
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

export const Footer = () => {
  const { t } = useTranslation();
  const { sidebarCollapsed: collapsed } = useAppLayout();

  const theme = useTheme();

  return (
    <Box display={collapsed ? "none" : "unset"}>
      <Box
        pt={3}
        borderTop={`1px solid ${alpha(
          theme.palette.sidebar.textOnSidebar,
          0.2
        )}`}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <LinksContainer>
            <StyledLink to="/impressum">
              <Typography
                variant="body3"
                color={theme.palette.sidebar.textOnSidebar}
              >
                {t("sidebar.footer.imprint")}
              </Typography>
            </StyledLink>
            <Dot />
            <StyledLink to="/privacy">
              <Typography
                variant="body3"
                color={theme.palette.sidebar.textOnSidebar}
              >
                {t("sidebar.footer.privacy")}
              </Typography>
            </StyledLink>
          </LinksContainer>
          <Typography
            variant="caption"
            color={theme.palette.sidebar.textOnSidebar}
          >
            © {t("sidebar.footer.wealthApi")}
          </Typography>
        </Box>
        <MandatorsSlugSelect />
      </Box>
    </Box>
  );
};
